import * as React from "react";
import { SVGProps } from "react";
const SvgInfoSecondaryLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#info-secondary-large_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c3.615 0 7.23.4 10.845 1.067 2.142.4 3.75 2 4.15 4.133a58.58 58.58 0 0 1 0 21.6c-.4 2.133-2.008 3.733-4.15 4.133C23.23 31.6 19.615 32 16 32s-7.23-.4-10.845-1.067c-2.142-.4-3.75-2-4.15-4.133-1.34-7.067-1.34-14.4 0-21.6.4-2.133 2.008-3.733 4.15-4.133C8.77.4 12.385 0 16 0Zm0 2c-3.322 0-6.78.35-10.478 1.033C4.19 3.28 3.218 4.249 2.97 5.566c-1.293 6.957-1.293 14.04 0 20.864.248 1.322 1.22 2.288 2.548 2.537C9.22 29.648 12.678 30 16 30c3.322 0 6.78-.35 10.478-1.033 1.332-.248 2.303-1.215 2.553-2.54a56.583 56.583 0 0 0 0-20.857c-.25-1.322-1.22-2.289-2.548-2.537C22.78 2.352 19.322 2 16 2Zm0 12c.828 0 1.5.624 1.5 1.393v10.214c0 .77-.672 1.393-1.5 1.393s-1.5-.624-1.5-1.393V15.393c0-.77.672-1.393 1.5-1.393Zm0-8a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="info-secondary-large_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfoSecondaryLarge;
